import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useAlertTypes = ({ returnPortalId }) => {
  const { data, loading } = useFetch(() => returnsServices.getAlertTypes({ returnPortalId }), {
    doInitialRequest: true,
  })

  return {
    alertTypes: data || [],
    fetchingAlertTypes: loading,
  }
}

export default useAlertTypes
